module.exports = __webpack_public_path__ + "img/head-img.6cfce513.png";